import { render, staticRenderFns } from "./floatDialog.vue?vue&type=template&id=51e82818&scoped=true"
import script from "./floatDialog.vue?vue&type=script&lang=js"
export * from "./floatDialog.vue?vue&type=script&lang=js"
import style0 from "./floatDialog.vue?vue&type=style&index=0&id=51e82818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e82818",
  null
  
)

export default component.exports